import GuildList from './GuildList'
import GuildShow from './GuildShow'

const guildsEntrypoints = {
  list: GuildList,
  show: GuildShow,
}

export default guildsEntrypoints
